// extracted by mini-css-extract-plugin
module.exports = {"video_container":"Video_video_container__moUZW","play_button_container":"Video_play_button_container__3dNzI","Shadow":"Video_Shadow__cPXTK"};